import 'youtube-background';
import fancybox from "./fancybox";

const hero = () => {
  const backgroundVideo = $('.js-video-background');

  if (backgroundVideo.length >= 1) {
    backgroundVideo.youtube_background();
    fancybox();
  }
}

export default hero;

